module.exports = __webpack_public_path__ + "static/media/2.aec2b40e.png";